import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class HeaderSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'header');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.fontFamilyField('font.family', ['main', 'content']),
            this.sizeNumberField('font.size'),
            this.fontWeightField('font.weight', ['main', 'content']),
            this.fontColorComboField('font.color', ['main', 'content', 'header']),
            this.fontTransformField('font.transform'),

            this.fontColorComboField('icon.color', ['header', 'main', 'content'], { ...this.preset('icon-color', 'main'), [this.translateValue('INHERIT')]: 'inherit' }),
            this.fontColorComboField('hover.icon.color', ['header', 'main', 'content'], this.preset('hover-font-color', 'main')),

            this.backgroundColorField('background.color', ['content', 'main']),
            this.borderColorField('border.color', ['main', 'content']),
            this.sizeNumberField('border.width', 'px'),
            
        ];
    }

}
